import { useState, useEffect } from 'react'
import { Loader } from '../components/loader';
import { useNavigate } from 'react-router-dom'
import { ErrorNotification, SuccessNotification } from '../components/notification';
import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { Heading } from '../components/heading'
import { Badge } from '../components/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { DocumentPlusIcon } from '@heroicons/react/16/solid';
import { Fragment } from 'react/jsx-runtime'
import { Footer } from '../components/footer'
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../components/dialog'
import { Button } from '../components/button'
import { PlusIcon, AdjustmentsHorizontalIcon, EllipsisVerticalIcon, UserGroupIcon } from '@heroicons/react/16/solid'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { PageInfo } from '../components/page-info'
import {  Pagination,  PaginationGap,  PaginationList, PaginationNext,  PaginationPage,  PaginationPrevious,} from '../components/pagination-new'
import config from '../config.js'
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '../components/dropdown'
import { useAlert } from "../components/customAlert";

const breadcrumbs_link = [
  { name: "Manage Users", href: "/manage-users",current: true }   
];
const page_info = `This section displays all your existing Users. To create a user, click the "Add New User" button.`;

export default function ProductTable () {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [successMsg, setSuccessMsg] = useState('');
  const [showSuccessBox, setShowSuccessBox] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [showErrorBox, setShowErrorBox] = useState(false);  
  const [users, setResults] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 5;
  const [total, setTotal] = useState(0);
  //const mail = '';//feeds@data.vu; //we use dynamic mail-id for corresponding acc 
  //const [popupMessage, setPopupMessage] = useState('');
  //const [popupHeading, setPopupHeading] = useState('');
  const [loading, setLoading] = useState(false);  
  const [confirmed, setConfirmed] = useState(false);//for confirmation
  let [isOpen, setIsOpen] = useState(false);
  let [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [selectedName, setSelectedName] = useState('');
  const [selectedEmail, setSelectedEmail] = useState('');
  const [selectedUserType, setSelectedUserType] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');
  
  
  // Fetch paginated product data
  const fetchResults = async (pageNum) => {
	  setLoading(true); // show loader	 
	   try {
			const res = await fetch(`${config.apiPath}/account-setup/account-handler.php?process=get_user_list&page=${pageNum}&limit=${limit}`,{ credentials: 'include' });
			const data = await res.json();
			//const res = '{"status":"success","users":[{"user_id":"12345","display_name":"Jegadeeshan S","user_type":"Sumo-Admin","created_on":"2025-08-01","email_address":"jegadeeshan@aroxo.com","mobile_number":"9876540271"},{"user_id":"234424","display_name":"Feroze","user_type":"Sumo-User","created_on":"2025-08-10","email_address":"feroze@aroxo.com","mobile_number":"456343465667"},{"user_id":"56876","display_name":"Paul","user_type":"Merchant-Admin","created_on":"2025-08-14","email_address":"paul@schuh.com","mobile_number":"5685645634"},{"user_id":"98454","display_name":"Peter","user_type":"Merchant-User","created_on":"2025-07-15","email_address":"peter@schuh.com","mobile_number":"7683455635"},{"user_id":"234234","display_name":"Steve","user_type":"Agent-Admin","created_on":"2025-07-07","email_address":"steve@anyahindmarch.com","mobile_number":"234567987"},{"user_id":"096456","display_name":"Lenin","user_type":"Agent-User","created_on":"2025-08-28","email_address":"lenin@anyahindmarch.com","mobile_number":"34564565788"}],"total":10}';
			//const data = JSON.parse(res);
			setResults(data.users);
			setTotal(data.total);
	   }catch(error){
		   console.error("Fetch error", error);
	   } finally {
    		setLoading(false); // hide loader
  		}
  };

  useEffect(() => {
    fetchResults(page);
  }, [page]);
  
  useEffect(() => {
  	if (confirmed) {
		  setConfirmed(false); // reset flag	
		  
      fetch(`${config.apiPath}/account-setup/account-handler.php?process=delete_user&user_id=${selectedUserId}`,{credentials: 'include' })
        .then((res) => res.json())
        .then((data) => {
          if(data.status==='success'){
            showAlert(data.msg, "" , "success",3000);              
          }else{
              showAlert(data.msg, "" , "error",3000);                 
          }
        });
		  
		  setSelectedIds([]);		  
		  fetchResults(page);
		}
	}, [confirmed, page, selectedIds]);

  // Handle checkbox toggle
  const deleteUser = (id) => {
	//console.log(id);
	if (!id) return; // prevent pushing undefined
	setSelectedIds([]);
	
	const selectedUser = users.find(u => u.user_id === id);
	
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
	
	setSelectedName(selectedUser.display_name);
	setSelectedEmail(selectedUser.email_address);
	setSelectedUserType(selectedUser.user_type);
  setSelectedUserId(id);

	// Show confirmation popup  	
		setIsOpenConfirm(true);   	
  	};
	
   

  const handleCancel = () => {
    setSelectedIds([]);
  };

  const totalPages = Math.ceil(total / limit);

  return (
  <Fragment>
    <SidebarLayoutNew selected_menu="addnewcompany">
	<BreadcrumbsNew pages={breadcrumbs_link} />
	<SuccessNotification showSuccessBox={showSuccessBox} successMsg={successMsg} setShowSuccessBox={setShowSuccessBox} />
    <ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
	
	
	<div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
          <UserGroupIcon className="!size-8" />
          <Heading>Manage Users</Heading> 
	  	  <Button className="-my-0.5 inline-flex justify-end gap-x-1.5 ml-auto" onClick={() => navigate("/manage-users/add")} >
		    <PlusIcon />
		      Add New User
		  </Button>  
    </div>
	
    <PageInfo info={page_info} />

      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>Display Name</TableHeader>
            <TableHeader>User Type</TableHeader>
            <TableHeader>Created On</TableHeader>
            <TableHeader>Email Address</TableHeader>
            <TableHeader>Mobile</TableHeader>
            <TableHeader>Actions</TableHeader>            
          </TableRow>
        </TableHead>
		{loading ? (
			<Loader />
		) : (
        <TableBody>
		   {total > 0 ?(			  
			  Object.values(users).map((user) => (
				<TableRow key={user.user_id}>
				  <TableCell>{user.display_name}</TableCell>
				  <TableCell>{user.user_type}</TableCell>
				  <TableCell>{user.addedon}</TableCell>
				  <TableCell>{user.email_address}</TableCell>
				  <TableCell>{user.mobile_number}</TableCell>				  			  
				  <TableCell>
					  <Dropdown>
                      <DropdownButton plain aria-label="More options">
                        <EllipsisVerticalIcon />
                      </DropdownButton>
                      <DropdownMenu anchor="bottom end">						
                        <DropdownItem onClick={() => deleteUser(user.user_id)}>Delete</DropdownItem> 
                        <DropdownItem onClick={() => navigate(`/manage-users/edit/id/${user.user_id}`)}>Edit</DropdownItem>
                      </DropdownMenu>
                      </Dropdown>
					</TableCell>
				</TableRow>
			  ))
		  ):(<TableRow><TableCell>No Users Found</TableCell></TableRow>)
		}
        </TableBody>
		)}
      </Table>
	  
	  {total > 0 && (
		<div className="mt-2 text-sm text-gray-600">
		  Showing {(page - 1) * limit + 1} – {Math.min(page * limit, total)} of {total}
		</div>
	  )}

      {/* Pagination start */}
		{total > limit && (
			<div className="mt-4 flex justify-center">
    <Pagination>
      <PaginationPrevious onClick={() => {page > 1 && setPage(page - 1)}} className={page === 1 ? "pointer-events-none opacity-50" : ""}/>
      <PaginationList>
        {getPaginationItems(page, totalPages).map((item, idx) =>
 		item === "..." ? (
    		<PaginationGap key={`gap-${idx}`} />
  		) : (
    	<PaginationPage  key={`page-${item}-${idx}`} current={item === page} onClick={() => setPage(item)}> 
     	{item}  
	 	</PaginationPage>
  		)
	  )}
      </PaginationList>
      <PaginationNext onClick={() => page < totalPages && setPage(page + 1)} className={page === totalPages?"pointer-events-none opacity-50":""} />
    </Pagination>
  		 </div>
		)}
	{/* Pagination end */}  
    
	
	{/*dialog start*/}
		<Dialog open={isOpen} onClose={setIsOpen}>
		  <DialogTitle></DialogTitle>
		  <DialogDescription>
			
		  </DialogDescription>
		  <DialogBody>			
		  </DialogBody>
		  <DialogActions>
			<Button onClick={() => setIsOpen(false)}>
			  Close
			</Button>			
		  </DialogActions>
      </Dialog>
	{/*dialog end*/}
	
	{/*confirm dialog start*/}
	  <Dialog open={isOpenConfirm} onClose={setIsOpenConfirm} size="xl">
        <DialogTitle>Confirm</DialogTitle>
        <DialogDescription>Are you sure, you want to delete the below user?</DialogDescription>
        <DialogBody className="text-sm/6 text-zinc-900 dark:text-white">
			<Table>
			  <TableHead>
				<TableRow className="text-zinc-950 dark:text-white">
				  <TableHeader>Name</TableHeader>
				  <TableHeader>Email</TableHeader>
				  <TableHeader>User Type</TableHeader>
				</TableRow>
			  </TableHead>
			  <TableBody> 
			  	<TableRow>
			  		<TableCell className="text-zinc-500">{selectedName}</TableCell>
			  		<TableCell className="text-zinc-500">{selectedEmail}</TableCell>
			   		<TableCell className="text-zinc-500">{selectedUserType}</TableCell>
		  	   	</TableRow>
			  </TableBody>   
			</Table>    
        </DialogBody>
        <DialogActions>
          <Button plain onClick={() => setIsOpenConfirm(false)}>
            Cancel
          </Button>
          <Button color="indigo" onClick={() => {setIsOpenConfirm(false);setConfirmed(true);}}>Yes Proceed</Button>
        </DialogActions>
      </Dialog>
	{/*confirm dialog end*/} 
	
	</SidebarLayoutNew>
       <Footer />
    </Fragment>
  );
}

function getPaginationItems(currentPage, totalPages) {
  const delta = 1; // how many pages to show around currentPage
  const range = [];
  const rangeWithDots = [];

  // Build raw page range
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - delta && i <= currentPage + delta)
    ) {
      range.push(i);
    }
  }

  // Insert gaps ("...") where needed
  let lastPage;
  for (let i of range) {
    if (lastPage !== undefined) {
      if (i - lastPage === 2) {
        rangeWithDots.push(lastPage + 1); // add missing page
      } else if (i - lastPage > 2) {
        rangeWithDots.push("...");
      }
    }
    rangeWithDots.push(i);
    lastPage = i;
  }

  return rangeWithDots;
}
